"use strict";

var ClassicInvitationSuite = require('./ClassicInvitationSuite');

var ClassicInvitationSuiteReprints = require('./ClassicInvitationSuiteReprints');

var RibbonInvitationSuite = require('./RibbonInvitationSuite');

var RibbonInvitationSuiteReprints = require('./RibbonInvitationSuiteReprints');

var VellumInvitationSuite = require('./VellumInvitationSuite');

var VellumInvitationSuiteReprints = require('./VellumInvitationSuiteReprints');

var FlatInvitationSuiteReprintsCovid = require('./FlatInvitationSuiteReprintsCovid');

var FloralInvitationSuite = require('./FloralInvitationSuite');

var FloralInvitationSuiteReprints = require('./FloralInvitationSuiteReprints');

var LetterpressInvitationSuite = require('./LetterpressInvitationSuite');

var LetterpressInvitationSuiteReprints = require('./LetterpressInvitationSuiteReprints');

var LetterpressInvitationSuiteReprintsCovid = require('./LetterpressInvitationSuiteReprintsCovid');

module.exports = {
  ClassicInvitationSuite: ClassicInvitationSuite,
  ClassicInvitationSuiteReprints: ClassicInvitationSuiteReprints,
  RibbonInvitationSuite: RibbonInvitationSuite,
  RibbonInvitationSuiteReprints: RibbonInvitationSuiteReprints,
  VellumInvitationSuite: VellumInvitationSuite,
  VellumInvitationSuiteReprints: VellumInvitationSuiteReprints,
  FlatInvitationSuiteReprintsCovid: FlatInvitationSuiteReprintsCovid,
  FloralInvitationSuite: FloralInvitationSuite,
  FloralInvitationSuiteReprints: FloralInvitationSuiteReprints,
  LetterpressInvitationSuite: LetterpressInvitationSuite,
  LetterpressInvitationSuiteReprints: LetterpressInvitationSuiteReprints,
  LetterpressInvitationSuiteReprintsCovid: LetterpressInvitationSuiteReprintsCovid
};